/**
 * Formats errors into a standardized shape. No side effects (no Sentry, no logout); those are handled in interceptors.
 */
export const errorHandler = (error, options = {}) => {
  if (error?.response) {
    const { status, data } = error.response;
    const errorData = {
      success: false,
      error: {
        status,
        message: data?.error || data?.message || "An error occurred",
        data: data,
      },
      statusCode: status,
    };

    const isAuthError =
      status === 401 ||
      data?.error?.toLowerCase()?.includes("token") ||
      data?.message?.toLowerCase()?.includes("token");

    if (isAuthError) {
      return {
        ...errorData,
        error: {
          ...errorData.error,
          message: "Session expired. Please login again.",
          redirectToLogin: true,
        },
      };
    }

    return errorData;
  }

  if (error?.request || (error instanceof TypeError && error.message.includes("fetch"))) {
    return {
      success: false,
      error: {
        message: "Network error. Please check your internet connection and try again.",
        type: "network_error",
      },
      statusCode: 0,
    };
  }

  if (error?.name === "SyntaxError" && error.message.includes("JSON")) {
    return {
      success: false,
      error: {
        message: "Invalid response format from server",
        type: "parse_error",
      },
      statusCode: 0,
    };
  }

  return {
    success: false,
    error: {
      message: error?.message || "An unexpected error occurred",
      type: "unknown_error",
    },
    statusCode: error?.status || 0,
  };
};

export const createErrorFromResponse = async (response) => {
  let errorData = {};
  try {
    errorData = await response.json();
  } catch {
    errorData = { message: "Invalid JSON response from server" };
  }

  return {
    response: {
      status: response.status,
      data: errorData,
    },
  };
};

export default errorHandler;
